import styled, { css } from 'styled-components';

const pill = css`
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.025em;
  text-transform: uppercase;
`;

const variants = {
  default: css`
    background-color: var(--primary);
    color: var(--primary-foreground);
  `,
  secondary: css`
    background-color: var(--secondary);
    color: var(--secondary-foreground);
  `,
  outline: css`
    border-color: var(--border);
    color: var(--foreground);
  `,
  // Marketing label ("New"): brand indigo pill.
  brand: css`
    background-color: var(--primary);
    color: var(--primary-foreground);
    ${pill};
  `,
  // Secondary marketing label: brand pink pill.
  accent: css`
    background-color: var(--brand-pink);
    color: var(--primary-foreground);
    ${pill};
  `,
};

/**
 * Small status / label pill.
 *
 *   <Badge $variant="brand">New</Badge>
 */
const Badge = styled.span`
  align-items: center;
  border: 1px solid transparent;
  border-radius: 9999px;
  box-sizing: border-box;
  display: inline-flex;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 500;
  gap: 4px;
  height: 20px;
  justify-content: center;
  line-height: 1;
  overflow: hidden;
  padding: 2px 8px;
  white-space: nowrap;
  width: fit-content;

  > svg {
    height: 12px;
    pointer-events: none;
    width: 12px;
  }

  ${({ $variant }) => variants[$variant] || variants.default};
`;

export default Badge;
